// extracted by mini-css-extract-plugin
export default {"backInStockButton":"zW6LYz","fullWidth":"m93aEz"};